// Single source of truth for Safer's WhatsApp support number — every page
// that links out to WhatsApp imports from here instead of hardcoding the
// number, so a future number change is a one-line edit, not a grep-and-replace.
export const WHATSAPP_NUMBER = '249113000553';
export const WHATSAPP_DISPLAY = '+249 113 000 553';
export const PHONE_TEL = `tel:+${WHATSAPP_NUMBER}`;

// Plain support link, or with an optional prefilled message.
export const whatsappUrl = (message) =>
  message
    ? `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
    : `https://wa.me/${WHATSAPP_NUMBER}`;
